import { AUTH } from "constants/api"
import useMainClass from "hooks/use-main-cass"
import { useContext, useEffect, useState } from "react"
import ErrorView from "components/error-view"
import axios, { AxiosError } from "axios"
import { useLocation, useParams } from "react-router-dom"
import { LoaderContext } from "contexts/loader-context"
import ViewStart from "./component/view-start"
import ViewForm from "./component/view-form"

export interface IBodyLoginExternal {
  "genreId"?: number,
  "isLogin"?: boolean,
  "provider": "Google" | "Email" | 'Facebook',
  "subscribe"?: boolean,
  "termsOfUse"?: boolean,
  "accessToken"?: string
  "birthday"?: string,
  "firstName": string,
  "lastName"?: string,
  "nickName"?: string,
  "utm"?: any,
  "email": string,
  "phone"?: string,
  "macAddress"?: string
}

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

export default function WifiAuth() {
  useMainClass('wifi__auth')
  const [stepper, setStepper] = useState<'start' | 'form'>('start')
  const [error, setError] = useState<string | number>()
  const params: any = useParams()
  const query = useQuery()
  const { setLoad } = useContext(LoaderContext)
  const paramNodeId = params?.type === 'Linktek' ? 'client_mac' : 'node_id'
  const paramContinueUrl = params?.type === 'Linktek' ? 'continue_url' : 'user_continue_url'
  const paramBaseGrantUrl = params?.type === 'Linktek' ? 'login_url' : 'base_grant_url'
  const userContinueUrl = query.get(paramContinueUrl) || ''
  const baseGrantUrl = query.get(paramBaseGrantUrl)
  const devTest = query.get('dev_test')
  const actionForm = params?.type === 'Linktek' ? baseGrantUrl : `${baseGrantUrl}?continue_url=${userContinueUrl}`
  const macAddress = query.get(paramNodeId)

  const isStepper = (match: string) => stepper === match

  function updateQueryParam(url: string, param: string, newValue: string): string {
    const urlObj = new URL(url);
    urlObj.searchParams.set(param, newValue);
    return urlObj.toString();
  }

  const handleLoginExternal = async (body: IBodyLoginExternal) => {
    setLoad(true)
    try {
      const { data } = await axios.post(`${AUTH}/external?apiToken=${API_TOKEN ?? 'a0755887-da8e-4bc1-a54b-285da5194da6'}`, { ...body, macAddress }, {
        headers: { 'Ph-Api-Id': PH_API_ID ?? 1, Authorization: API_TOKEN ?? 'a0755887-da8e-4bc1-a54b-285da5194da6' }
      })

      const formElement: HTMLFormElement = document.getElementById('form-action') as any
      const updatedActionForm = updateQueryParam(actionForm, 'continue_url', data);
      formElement.action = updatedActionForm;

      const inputName = document.createElement("input");
      inputName.name = 'username';
      inputName.id = 'username';
      inputName.defaultValue = body?.email || '';
      inputName.value = body?.email || '';
      inputName.type = 'email';

      const inputPassword = document.createElement("input");
      inputPassword.name = 'password';
      inputPassword.id = 'password';
      inputPassword.defaultValue = body?.phone || '';
      inputPassword.value = body?.phone || '';
      inputPassword.type = 'tel';

      const inputSuccess = document.createElement("input");
      inputSuccess.name = 'success_url';
      inputSuccess.id = 'success_url';
      inputSuccess.defaultValue = data;
      inputSuccess.value = data;
      inputSuccess.type = 'text';

      formElement.appendChild(inputName);
      formElement.appendChild(inputPassword);
      formElement.appendChild(inputSuccess);
      setTimeout(() => {
        formElement.submit()
      }, 1000)
    } catch (error) {
      console.log(error)
      const code = (error as AxiosError).response?.data.code || 99999
      setError(code)
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    const formElement = document.createElement("form");
    formElement.style.display = "none";
    formElement.classList.add("custom-form");
    formElement.id = "form-action";
    formElement.action = `${actionForm}`
    formElement.method = devTest ? 'get' : 'post'
    document.body.appendChild(formElement);
  }, [])

  if (error) return (
    <ErrorView
      code={error}
      buttonMenu={() => setError(undefined)}
      onRetry={() => setError(undefined)}
    />
  )

  if (isStepper('form')) return <ViewForm setStepper={setStepper} setError={setError} handleLoginExternal={handleLoginExternal} />

  if (isStepper('start')) return <ViewStart setStepper={setStepper} setError={setError} handleLoginExternal={handleLoginExternal} />

  return (
    <></>
  )
}